<template>
  <v-dialog persistent v-model="cashDialog" width="780px">
    <v-card>
      <v-card-title>
          <span class="headline">
            {{ $t("LakalaAccount.Cash.title") }}
          </span>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="cashDialog = false">
              fa-times
            </v-icon>
          </template>
          <span>
              {{ $t("CRUD.backToList", [$t("LakalaAccount.title")]) }}
            </span>
        </v-tooltip>
      </v-card-title>

      <v-card-text>
        <v-container>
           <ValidationObserver ref="observer">
          <v-form>
            <v-row>
              <!-- 汇付商户号 -->
              <v-col cols="6">
                  <span >
                    {{ $t("LakalaAccount.Cash.lakala_member_no") + $t("Global.colon") }}
                  </span>
                <span class="green--text">
                  {{ lakalaAccount.lakala_member_no }}
                  </span>
              </v-col>
              <!-- 账户余额 -->
              <v-col cols="6">
                  <span>
                    {{ $t("LakalaAccount.Cash.totalAmount") }}{{ $t("Global.colon") }}
                  </span>
                <span class="red--text">
                   {{ $t("Global.money") }}{{ totalAmount | formatMoney }}
                  </span>
              </v-col>
                <!-- 冻结余额 -->
                <v-col cols="6">
                  <span>
                    {{ $t("LakalaAccount.Cash.freezeAmount") }}{{ $t("Global.colon") }}
                  </span>
                    <span class="red--text">
                   {{ $t("Global.money") }}{{ freezeAmount | formatMoney }}
                  </span>
                </v-col>
                <!-- 可用余额 -->
                <v-col cols="6">
                  <span>
                    {{ $t("LakalaAccount.Cash.availableAmount") }}{{ $t("Global.colon") }}
                  </span>
                    <span class="red--text">
                   {{ $t("Global.money") }}{{ availableAmount | formatMoney }}
                  </span>
                </v-col>
              <!-- 手续费 -->
              <v-col cols="6">
                  <span>
                    {{ $t("LakalaAccount.Cash.feeAmt") }}{{ $t("Global.colon") }}
                  </span>
                <span class="red--text">
                   {{ $t("Global.money") }}{{ cashFee | formatMoney }}
                  </span>
              </v-col>
              <!-- 预计到账金额 -->
              <v-col cols="6">
                  <span>
                    {{ $t("LakalaAccount.Cash.expCashAmt") }}{{ $t("Global.colon") }}
                  </span>
                <span class="red--text">
                   {{ $t("Global.money") }}{{ (cashAmt - cashFee) | formatMoney }}
                  </span>
              </v-col>
              <!-- 取现方式-->
              <v-col cols="12">
                  <span>
                    {{ $t("ReceiptDetail.receipt.payment_method") }}{{ $t("Global.colon") }}
                  </span>
                  <span class="green--text">
                      T1
                  </span>
                </v-col>
              <!-- 提现卡号-->
              <v-col cols="12">
                  <ValidationProvider
                          v-slot="{ errors }"
                          :name="$t('LakalaAccount.Cash.cashCard')"
                          rules="required"
                  >
                  <span class="d-flex">
                    {{ $t("LakalaAccount.Cash.cashCard") }}{{ $t("Global.colon") }}
                    <v-select
                            style="padding-top: 0px"
                            v-model="cardSelected"
                            :items="lklAccountCards"
                            item-text="Description"
                            item-value="card_id"
                            :disabled="isCashAmtDisabled"
                            :error-messages="errors"
                            clearable
                    >
                        <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-select>
                  </span>
                  </ValidationProvider>
                </v-col>
              <!-- 提现金额-->
              <v-col cols="6">
                  <ValidationProvider
                          v-slot="{ errors }"
                          :name="$t('LakalaAccount.Cash.cashAmt')"
                          :rules="{
                                    max_value: {
                                        max: parseFloat((availableAmount - cashFee)).toFixed(2),
                                    },
                                    min_value: {
                                        min: 0.01,
                                    },
                                    required: {
                                        required: true
                                    }
                                }"
                  >
                  <span class="d-flex">
                    {{ $t("LakalaAccount.Cash.cashAmt") }}{{ $t("Global.colon") }}
                    <v-text-field
                            v-model="cashAmt"
                            single-line
                            dense
                            type="number"
                            min="0"
                            :disabled="isCashAmtDisabled"
                            :prefix="$t('Global.money')"
                            :error-messages="errors"
                            @blur="cashAmt = $numberFormatter.formatMoney(cashAmt)"
                    ><template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </span>
                  </ValidationProvider>
              </v-col>
              <!-- 验证码 -->
              <v-col cols="6" v-if="isCashAmtDisabled">
                  <span class="d-flex">
                    {{ $t("LakalaAccount.Pay.VCode") }}{{ $t("Global.colon") }}
                    <v-text-field
                            v-model="VCode"
                            single-line
                            dense
                            persistent-hint
                            :hint="$t('LakalaAccount.vc_code_hint')"
                    />
                  </span>
                </v-col>
            </v-row>
          </v-form>
           </ValidationObserver>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="cashDialog = false">{{ $t("$vuetify.close") }}</v-btn>
          <v-btn color="accent" @click="submit()">{{ $t("CRUD.confirm") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from "@/i18n";
import Payment from "@/api/payment";
import LakalaInterface from "@/api/lakala_interface";
import ThirdAccountInfo from "@/api/third-account-info"
import { ValidationObserver, ValidationProvider } from "vee-validate";


export default {
    name: "cashDialog",

    props: {
        value: Boolean,
        cashItem: Object
    },
    computed: {
        lklAccountCards() {
            return this.cardItem.map((detail) => {
                detail.Description = i18n.t("SubAccount.hfCash.description", [
                    detail.bank_name,
                    detail.card_no,
                ]);
                return detail;
            });
        },
    },
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data: () => ({
        cashDialog: false,
        lakalaAccount: {},
        cashAmt: null,
        cashFee: 0,
        expCashAmt: 0,
        totalAmount: 0,
        freezeAmount: 0,
        availableAmount: 0,
        cardItem: [],
        cardSelected: null,
        VCode: null,
        cashCode: null,
        isCashAmtDisabled: false,
    }),
    mounted() {

    },
    methods: {
        getBalanceAmt() {
            //获取汇付账户余额
            if (this.lakalaAccount.lakala_member_no) {
                //获取汇付总账户ID
                Payment.fetch({
                    keys: [
                        "lakala_cash_fee", // 拉卡拉手续费
                    ],
                }).then((settingResponse) => {
                    if (settingResponse.data.status.isOK()) {
                        this.cashFee = settingResponse.data.settings.lakala_cash_fee;
                    }
                })
                LakalaInterface.queryBalance({member_no: this.lakalaAccount.lakala_member_no}).then((response) => {
                    if (response.data.status.isOK()) {
                        this.totalAmount = parseFloat((response.data.result.total_amount / 100)).toFixed(2)
                        this.freezeAmount = parseFloat((response.data.result.freeze_amount / 100)).toFixed(2)
                        this.availableAmount = parseFloat((response.data.result.available_amount / 100)).toFixed(2)
                        LakalaInterface.queryCard({member_no: this.lakalaAccount.lakala_member_no}).then((UserResponse) => {
                            if (UserResponse.data.status.isOK) {
                                this.cardItem = UserResponse.data.result;
                            }
                        })
                    }
                })
            }
        },
        submit() {
            if (!this.isCashAmtDisabled) {
                this.$refs.observer.validate().then(
                    async function (result) {
                        if (result) {
                            let submitData = {
                                lkl_member_no: this.lakalaAccount.lakala_member_no,
                                cash_type: 102, // 支付类型：拉卡拉：102
                                cash_amt: this.cashAmt,
                                card_token_no: this.cardSelected
                            }
                            ThirdAccountInfo.addLklEnchashment(submitData).then((cashResponse) => {
                                if (cashResponse.data.status.isOK()) {
                                    this.cashCode = cashResponse.data.third_cash_records.cash_code
                                    if (cashResponse.data.mobile_validation_flg && cashResponse.data.mobile_validation_code != '') {
                                        let submitData = {
                                            cash_code: this.cashCode,
                                            validation_code: cashResponse.data.mobile_validation_code
                                        }
                                        LakalaInterface.enchashment(submitData).then(
                                            function (response) {
                                                if (response.data.status.isOK()) {
                                                    this.$snackbar.success(i18n.t("LakalaAccount.Cash.successMsg"));
                                                    this.cashDialog = false
                                                }
                                            }.bind(this)
                                        )
                                    } else {
                                        ThirdAccountInfo.mobileValidation({third_record_code: this.cashCode, type: 2}).then((response) => {
                                            if (response.data.status.isOK()) {
                                                this.$snackbar.success(i18n.t("LakalaAccount.Cash.mobileVCode"));
                                                this.isCashAmtDisabled = true
                                            }
                                        })
                                    }
                                }
                            })
                        }
                    }.bind(this)
                )
            }else if (this.VCode != '') {
                let submitData = {
                    cash_code: this.cashCode,
                    validation_code: this.VCode
                }
                LakalaInterface.enchashment(submitData).then(
                    function (response) {
                        if (response.data.status.isOK()) {
                            this.$snackbar.success(i18n.t("LakalaAccount.Cash.successMsg"));
                            this.cashDialog = false
                        }
                    }.bind(this)
                )
            }
        },
    },

    watch: {
        value: {
            immediate: false, //初始赋值也调用
            handler() {
                if (this.value) {
                    this.getBalanceAmt()
                } else {
                    this.lakalaAccount = {};
                    this.cashAmt = null;
                    this.expCashAmt = 0;
                    this.cashFee = 0;
                    this.totalAmount = 0;
                    this.freezeAmount = 0;
                    this.availableAmount = 0;
                    this.cardItem = [];
                    this.cardSelected = null;
                    this.VCode = null;
                    this.cashCode = null;
                    this.isCashAmtDisabled = false;
                    this.$refs.observer.reset();
                }
                this.cashDialog = this.value;
            },
        },
        cashItem: {
            immediate: false, //初始赋值也调用
            handler() {
                this.lakalaAccount = this.cashItem;
                if (this.cashItem) {
                    this.getBalanceAmt()
                }
            },
        },
        cashDialog: {
            handler() {
                this.$emit("input", this.cashDialog);
            },
        }
    },
};
</script>